import { Skeleton } from "@progress/kendo-react-indicators";

import "./SkeletonForm.css";

const SkeletonForm = () => {
  return (
    <div className="skeletonform__container">
      <Skeleton shape="rectangle" style={{ width: 600, height: 100 }} />

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 250, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 350, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 250, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 350, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 250, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 350, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 250, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 350, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>

      <div className="skeletonform__group">
        <Skeleton
          shape="text"
          style={{ width: 250, marginTop: 25, borderRadius: "0.8em" }}
        />
        <Skeleton shape="rectangle" style={{ width: 600, height: 50 }} />
      </div>
    </div>
  );
};

export default SkeletonForm;
